export default __webpack_public_path__ + "static/media/toolsathand.32837121.png";